import * as React from 'react';
import { ColorSwatchSmallWrapper } from './ColorSwatchSmall_SC';
export interface Props {
  color: string;
  text: string;
}

export const ColorSwatchSmall: React.FC<Props> = (props) => {
  const { color, text } = props;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <ColorSwatchSmallWrapper color={color} hasBorder={text === 'XIColorUsage.silver' || text === 'white.primary'} />
      <p style={{ marginLeft: 12 }}>{text}</p>
    </div>
  );
};
